import React, { FC } from 'react';
import classNames from 'classnames';
import { omit } from 'lodash';
import { Grid, Typography } from '@material-ui/core';

import { PublicUserProfile } from 'api';
import { UserAvatar } from 'components';
import { getFullName } from 'helpers';

import { IMentionsTheme } from '../types';

interface IProps {
  mention: PublicUserProfile;
  isFocused: boolean;
  theme: IMentionsTheme;
}

const Mention: FC<IProps> = ({ mention, isFocused, theme, ...parentProps }) => {
  const propsToPass = omit(parentProps, ['searchValue', 'className']);
  const containerClasses = classNames(theme.mentionSuggestionsEntry, {
    [theme.mentionSuggestionsEntryFocused]: isFocused,
  });

  return (
    <Grid container className={containerClasses} alignItems="center" {...propsToPass}>
      <Grid item>
        <UserAvatar user={mention} />
      </Grid>
      <Grid item xs>
        <Typography color="inherit" className={theme.mentionSuggestionsEntryText}>
          {getFullName(mention)}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default Mention;
